/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePhaseDto } from '../../models/response-phase-dto';

export interface PhasesControllerFindByPathwayId$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway identifier
 */
  pathwayId: string;
}

export function phasesControllerFindByPathwayId(http: HttpClient, rootUrl: string, params: PhasesControllerFindByPathwayId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePhaseDto>>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerFindByPathwayId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('pathwayId', params.pathwayId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponsePhaseDto>>;
    })
  );
}

phasesControllerFindByPathwayId.PATH = '/thalea-pathways/phases/pathway/{tenant}/{pathwayId}';
